import { loadStripe } from '@stripe/stripe-js/pure';
import { stripePublishableKey } from '../data/constants';
import { hasValue } from '../utils/helpers';

let stripeCache = {};

export async function loadStripeWithAccount(accountId) {
  try {
    // If the Stripe instance is cached and still valid, return it
    if (hasValue(accountId) && stripeCache[accountId]?.stripe) {
      return stripeCache[accountId].stripe;
    }

    // If the accountId is present, we are using a connected account
    // and need to pass the accountId to the Stripe instance.
    // This is used to determine which account to charge.
    const stripeOptions = accountId ? { stripeAccount: accountId } : {};
    const stripe = await loadStripe(stripePublishableKey, stripeOptions);

    // Cache the Stripe instance
    if (hasValue(accountId)) {
      stripeCache[accountId] = { stripe };
    }

    return stripe;
  } catch (error) {
    console.log('The payment library (Stripe) did not load correctly', error);
    throw error;
  }
}
